import { Post } from '../helpers';
import { BrandliveEvent } from '@/types/projects.types';

const DuplicateProject = ({
  channel,
  projectUuid,
}: {
  channel: number;
  projectUuid: string;
}): Promise<BrandliveEvent> => {
  return Post({
    path: `/v3/admin/events/duplicate-event/${projectUuid}`,
    body: { channel },
  });
};

export default DuplicateProject;
